import * as React from "react"

const MOBILE_BREAKPOINT = 768

/**
 * Custom hook to determine if the current device is mobile based on window width.
 * Returns true if the viewport is less than MOBILE_BREAKPOINT pixels wide.
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(false)
  const mediaQueryRef = React.useRef<MediaQueryList | null>(null)

  React.useEffect(() => {
    // Create media query list
    mediaQueryRef.current = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    
    // Set initial value
    setIsMobile(mediaQueryRef.current.matches)

    // Create event handler
    const handleChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches)
    }

    // Add event listener
    mediaQueryRef.current.addEventListener("change", handleChange)

    // Cleanup
    return () => {
      if (mediaQueryRef.current) {
        mediaQueryRef.current.removeEventListener("change", handleChange)
      }
    }
  }, [])

  return isMobile
}
